import {ChestEvalGenStareSanFieldNames} from "../chest-eval-gen-stare-sanatate.types";

export class BullInfAnsw{
    txt: string;
    id: ChestEvalGenStareSanFieldNames;
    inverted: boolean;
    hasL2: boolean;
}

export class BulInfQ {
    q: string;
    answsL1: BullInfAnsw[];
    answsL2: BullInfAnsw[];
}
export const bulInfQuestions: BulInfQ[] = [
    {
        q: "1. Aţi mai urmat tratamente stomatologice sub anestezie locală/loco-regională?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info1_1, inverted: true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info1_1, inverted:false, hasL2: true, txt: "DA {tick}. Au apărut complicații?"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info1_2, inverted:true, hasL2: false,txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info1_2, inverted:false, hasL2: false, txt: "DA {tick}. Precizaţi ce complicații: ...{extra}..."},
        ],
    },
    {
        q: "2. Sunteți alergic la un medicament?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info2_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info2_1, inverted:false, hasL2: false, txt: "DA {tick}. Precizaţi la ce medicament: ...{extra}..."},
        ],
        answsL2: [],
    },
    {
        q: "3. Urmaţi tratament cu unul din următoarele medicamente?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_1, inverted:false, hasL2: true, txt: "DA {tick}"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_2, inverted:false, hasL2: false, txt: "antiagregante (Plavix, Aspirină) {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_3, inverted:false, hasL2: false, txt: "anticoagulante (Sintrom, Trombostop, Acenocumarol) {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_4, inverted:false, hasL2: false, txt: "corticoizi (Prednison) {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_5, inverted:false, hasL2: false, txt: "citostatice {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_6, inverted:false, hasL2: false, txt: "imunosupresoare {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info3_7, inverted:false, hasL2: false, txt: "bifosfonaţi (Fosamax, Zometa) {tick}"},
        ],
    },
    {
        q: "4. Urmaţi un alt tratament medicamentos prescris de medic?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info4_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info4_1, inverted:false, hasL2: false, txt: "DA {tick}. Precizaţi ce medicamente: ...{extra}..."},
        ],
        answsL2: [],
    },
    {
        q: "5. Aţi suferit intervenţii chirurgicale?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info5_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info5_1, inverted:false, hasL2: false, txt: "DA {tick}. Precizaţi ce intervenţii: ...{extra}..."},
        ],
        answsL2: [],
    },
    {
        q: "6. Aţi efectuat analize de sânge în ultimul an?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info6_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info6_1, inverted:false, hasL2: false, txt: "DA {tick}"},
        ],
        answsL2: [],
    },
    {
        q: "7. Ati fost diagnosticat cu afecţiuni congenitale?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info7_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info7_1, inverted:false, hasL2: false, txt: "DA {tick}. Precizaţi care: ...{extra}..."},
        ],
        answsL2: [],
    },
    {
        q: "8. Aţi suferit vreodată pierederea stării de conştienţă?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info8_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info8_1, inverted:false, hasL2: false, txt: "DA {tick}"},
        ],
        answsL2: [],
    },
    {
        q: "9. Aţi fost diagnosticat cu afecţiuni infecţioase?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info9_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info9_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info9_2, inverted:false, hasL2: false, txt: "hepatită (B,C,D) {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info9_3, inverted:false, hasL2: false, txt: "sifilis {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info9_4, inverted:false, hasL2: false, txt: "TBC {tick}"},
        ],
    },
    {
        q: "10. Ati fost diagnosticat cu infecţie HIV/ SIDA?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info10_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info10_1, inverted:false, hasL2: false, txt: "DA {tick}"},
        ],
        answsL2: [],
    },
    {
        q: "11. Ați fost diagnosticat cu afecţiuni cardio-vasculare?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_2, inverted:false, hasL2: false, txt: "cardiopatie ischemică cronică {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_3, inverted:false, hasL2: false, txt: "angină pectorală {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_4, inverted:false, hasL2: false, txt: "infarct miocardic {tick}. Precizați momentul producerii acestuia: ...{extra}..."},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_5, inverted:false, hasL2: false, txt: "aritmii (extrasistole, tahicardie, fibrilaţie, flutter)  {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_6, inverted:false, hasL2: false, txt: "tulburări de conducere (blocuri)  {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_7, inverted:false, hasL2: false, txt: "insuficienţă cardiacă {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_8, inverted:false, hasL2: false, txt: "hipertensiune arterială {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_9, inverted:false, hasL2: false, txt: "hipotensiune arterială {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_10, inverted:false, hasL2: false, txt: "endocardită infecţioasă {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_11, inverted:false, hasL2: false, txt: "proteză vasculară/valvulară {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info11_12, inverted:false, hasL2: false, txt: "pacemaker/stimulator cardiac {tick}"},
        ],
    },
    {
        q: "12. Aţi fost diagnosticat cu afecţiuni neurologice?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info12_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info12_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info12_2, inverted:false, hasL2: false, txt: "epilepsie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info12_3, inverted:false, hasL2: false, txt: "Parkinson {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info12_4, inverted:false, hasL2: false, txt: "accident vascular cerebral  {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info12_5, inverted:false, hasL2: false, txt: "scleroză multiplă (în plăci) {tick}"},
        ],
    },

    {
        q: "13. Aţi fost diagnosticat cu afecţiuni respiratorii?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info13_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info13_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info13_2, inverted:false, hasL2: false, txt: "astm bronşic {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info13_3, inverted:false, hasL2: false, txt: "bronşită cronică {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info13_4, inverted:false, hasL2: false, txt: "emfizem {tick}"},
        ],
    },

    {
        q: "14. Aţi fost diagnosticat cu afecţiuni hepatice?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info14_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info14_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info14_2, inverted:false, hasL2: false, txt: "hepatită {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info14_3, inverted:false, hasL2: false, txt: "porfirie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info14_4, inverted:false, hasL2: false, txt: "insuficienţă hepatică {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info14_5, inverted:false, hasL2: false, txt: "ciroză hepatică {tick}"},
        ],
    },

    {
        q: "15. Ați fost diagnosticat cu afecţiuni renale?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info15_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info15_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info15_2, inverted:false, hasL2: false, txt: "litiază renală {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info15_3, inverted:false, hasL2: false, txt: "insuficienţă renală cronică {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info15_4, inverted:false, hasL2: false, txt: "hemodializă {tick}"},
        ],
    },

    {
        q: "16. Ați fost diagnosticat cu afecţiuni autoimune?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_2, inverted:false, hasL2: false, txt: "poliartrită reumatoidă  {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_3, inverted:false, hasL2: false, txt: "lichen plan {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_4, inverted:false, hasL2: false, txt: "lupus eritematos {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_5, inverted:false, hasL2: false, txt: "pemfigus {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_6, inverted:false, hasL2: false, txt: "sclerodermie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info16_7, inverted:false, hasL2: false, txt: "psoriazis {tick}"},
        ],
    },

    {
        q: "17. Aţi fost diagnosticat cu afecţiuni sanguine?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care:"},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_2, inverted:false, hasL2: false, txt: "anemie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_3, inverted:false, hasL2: false, txt: "thalasemie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_4, inverted:false, hasL2: false, txt: "trombocitopenie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_5, inverted:false, hasL2: false, txt: "trombocitopatief {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_6, inverted:false, hasL2: false, txt: "hipersplenism {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_7, inverted:false, hasL2: false, txt: "leucemie acută {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_8, inverted:false, hasL2: false, txt: "leucemie cronică {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_9, inverted:false, hasL2: false, txt: "mielom multiplu {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info17_10, inverted:false, hasL2: false, txt: "altele (precizaţi) {tick} ...{extra}..."},
        ],
    },

    {
        q: "18. Aţi fost diagnosticat cu tumori maligne?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info18_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info18_1, inverted:false, hasL2: false, txt: "DA {tick}. Precizați diagnosticul: ...{extra}..."},
        ],
        answsL2: [],
    },

    {
        q: "19. Aţi fost diagnosticat cu diabet?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info19_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info19_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi ce tratament urmaţi: "},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info19_2, inverted:false, hasL2: false, txt: "Insulină {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info19_3, inverted:false, hasL2: false, txt: "Antidiabetice orale {tick}"},
        ],
    },

    {
        q: "20. Ați fost diagnosticat cu afecţiuni endocrine?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info20_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info20_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care: "},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info20_2, inverted:false, hasL2: false, txt: "hipotiroidism {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info20_3, inverted:false, hasL2: false, txt: "hipertiroidism {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info20_4, inverted:false, hasL2: false, txt: "Adisson {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info20_5, inverted:false, hasL2: false, txt: "feocromocitom {tick}"},
        ],
    },

    {
        q: "21. Aţi fost diagnosticat cu afecţiuni ale coagulării?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info21_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info21_1, inverted:false, hasL2: true, txt: "DA {tick}. Menţionaţi care: "},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info21_2, inverted:false, hasL2: false, txt: "hemofilie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info21_3, inverted:false, hasL2: false, txt: "boala von Willebra {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info21_4, inverted:false, hasL2: false, txt: "altele (precizati) {tick} ...{extra}..."},
        ],
    },

    {
        q: "22. Aţi fost diagnosticat cu afecţiuni psihice?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info22_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info22_1, inverted:false, hasL2: true, txt: "DA {tick}. Precizaţi care: "},
        ],
        answsL2: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info22_2, inverted:false, hasL2: false, txt: "depresie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info22_3, inverted:false, hasL2: false, txt: "schizofrenie {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info22_4, inverted:false, hasL2: false, txt: "dependență de alcool {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info22_5, inverted:false, hasL2: false, txt: "dependenţă de droguri {tick}"},
        ],
    },

    {
        q: "23. Sunteţi însărcinată?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info23_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info23_1, inverted:false, hasL2: false, txt: "DA {tick}. Precizați ce vârstă are sarcina: ...{extra}... "},
        ],
        answsL2: [],
    },

    {
        q: "24. Aţi fost diagnosticat cu afecţiuni sinuzale?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info24_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info24_1, inverted:false, hasL2: false, txt: "DA {tick}"},
        ],
        answsL2: [],
    },

    {
        q: "25. Aţi înţeles întrebările de mai sus?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info25_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info25_1, inverted:false, hasL2: false, txt: "DA {tick}"},
        ],
        answsL2: [],
    },

    {
        q: "26. Consideraţi că mai aveţi ceva de adăugat în legătură cu starea dvs. de sănătate?",
        answsL1: [
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info26_1, inverted:true, hasL2: false, txt: "NU {tick}"},
            { id: ChestEvalGenStareSanFieldNames.BUL_INFO_SB_V1__info26_1, inverted:false, hasL2: false, txt: "DA {tick}. Vă rugăm precizaţi: ...{extra}..."},
        ],
        answsL2: [],
    },
];
